/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcRaglV1ManualEntryEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_RAGL_V1_MANUAL_ENTRY_EVENT_ENTITY_NAME = 'ixc.ragl.v1.ManualEntryEvent';
export const ixcRaglV1ManualEntryEventEntity = new schema.Entity<IxcRaglV1ManualEntryEvent>(IXC_RAGL_V1_MANUAL_ENTRY_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        posted: new schema.Object({
            assets: [new schema.Object({
                    asset: ixcAssetsV1AssetStateEntity
                })]
        })
    })
}, { idAttribute: (entity: IxcRaglV1ManualEntryEvent) => `${entity.metadata?.eventId}` });

